import { CgArrowLongRight } from 'react-icons/cg';
// /blog lo sirve el proyecto Next.js vía rewrite de Firebase, así que NO es una
// ruta de este router: con <Link> la navegación se quedaría dentro del SPA y
// caería en el catch-all 404. Hace falta navegación real con <a href>.




// Las imágenes del CMS vienen con ESPACIOS en el nombre ("soluciones
// escalables.png"). Metidas tal cual en un `url(...)` sin comillas, el CSS es
// inválido, el navegador descarta la declaración entera y la tarjeta se queda
// sin imagen (ni siquiera la de reserva). Comillas + espacios codificados.
const cssUrl = (src) => `url("${String(src).replace(/ /g, '%20').replace(/"/g, '%22')}")`;

const HomeTwoSingleBlog = ({date, name, desc, link, article}) => {
   return (
      <>
         <div className="col-xl-4 col-lg-4 col-md-6">
            {/* minHeight y no height: con títulos reales del CMS (más largos que los de
                ejemplo) el "Read More" quedaba cortado por abajo. */}
            <div className="blog__item p-relative fix mb-30 white-bg"  style={{ flex: "0 0 300px", minHeight: "300px"}}>
               <div
                  className="blog__thumb"
                  style={{
                     backgroundImage: cssUrl(article?.image || "/assets/img/blog/blog-1.jpg"),
                     backgroundPosition: "center",
                     backgroundSize: "cover",
                     backgroundRepeat: "no-repeat"
                  }}
               ></div>
               <div className="blog__content">
                  <div className="blog__meta date mb-45">
                     <h4>{date}</h4>
                     {/* <h6>Nov 2021</h6> */}
                  </div>
                  <div className="blog__meta user mb-15">


                  </div>
                  <h3>
                     <a href={`/blog/${link}`}>{desc}</a>
                  </h3>
                  <div className="blog__btn">
                     <a href={`/blog/${link}`} className="link-btn-2">
                        Read More
                        <i > <CgArrowLongRight /> </i>
                        <i > <CgArrowLongRight /> </i>
                     </a>
                  </div>
               </div>
            </div>
         </div>
      </>
   );
};

export default HomeTwoSingleBlog;
